<div class="markets-wrapper">
  <div class="markets-content">

    <div class="mobile-only">
      <div class="cards-wrap">
        @for (_market of jobMarkets; track _market) {

          <div class="profession-card" (click)="goToHotMarketDetails(_market)">
            <a>
              <div class="carousel-image-wrapper">
                @if (_market?.photos[0]?.photo) {
                  <img [src]="_market.photos[0].photo">
                }
                @else {
                  <img [src]="'/assets/images/no_image_available.jpeg'">
                }
              </div>  

              <span>{{ _market.name }}, {{ _market.state }}</span>
            </a>
          </div>       
        }
      </div>
    </div>

    <div class="mobile-hidden">
      <mat-tab-group color="primary" mat-stretch-tabs="false" mat-align-tabs="center" animationDuration="2000ms">
        @for (_market of jobMarkets; track _market) {
          <mat-tab [label]="_market.city + ', ' + _market.state">
            <div class="tab-inner-content">
              <div class="market-info" (click)="goToHotMarketDetails(_market)">
                <div class="carousel-image-wrapper">
                  @if (_market?.photos[0]?.photo) {
                    <img [src]="_market.photos[0].photo">
                  }
                  @if (!_market?.photos[0]?.photo) {
                    <img [src]="'/assets/images/no_image_available.jpeg'">
                  }
                  @if (_market?.photos[0]?.html_attributions[0]) {
                    <figcaption class="image-cite">
                      Photo: <span [innerHTML]="_market.photos[0].html_attributions[0] | safeHtml" [matTooltip]="_market?.photos[0]?.citeToolTip" [matTooltipPosition]="'above'"></span>
                    </figcaption>
                  }
                </div>

                <div class="carousel-data-wrapper">
                  @if (_market?.name) {
                    <div
                      class="market-title"
                      [matTooltip]="_market.name"
                      matTooltipClass="market-name"
                      [matTooltipPosition]="'above'"
                      (click)="goToHotMarketDetails(_market)">
                      {{ _market.name }}, {{ _market.state }}
                    </div>
                  }
                </div>
              </div>

              <div class="jobs-for-market">
                @if (_market?.jobs?.length) {
                  <div class="job-list">
                    @for (_job of _market.jobs; track _job) {
                      <div class="job-row" (click)="sendToDetails(_job)">
                        <div class="featured-ribbon"><span>FEATURED</span></div>

                        <div class="title-location default-flex space-between">
                          <div class="title">
                            <h2 class="job-name"><span>{{ _job.name }}</span></h2>
                          </div>

                          <div class="details-row">
                            <div class="job-location">
                              @if (_job.city) {
                                <span>{{ _job.city }}, </span>
                              }
                              @if (_job.state) {
                                <span>{{ _job.state }}</span>
                              }
                            </div>
                            
                            <div class="job-age"><span class="age-label"></span></div>
                          </div>
                        </div>

                        <div class="job-description" [innerHTML]="(_job.short_job_description | ellipsis: 420) | safeHtml"></div>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </mat-tab>
        }
      </mat-tab-group>
    </div>
  </div>
</div>